export const GET_SESSION = /* GraphQL */ `
  query GetSession($sessionId: ID!) {
    getSession(sessionId: $sessionId) {
      sessionId
      userId
      phoneNumber
      status
      currentStep
      lastUpdatedAt
      expiresAt
      bookingState {
        searchParams {
          origin
          destination
          departureDate
          returnDate
          cabinClass
          passengerCount
        }
        selectedFlight {
          flightId
          flightNumber
          airline
          origin
          destination
          departureTime
          arrivalTime
          durationMinutes
          cabinClass
          price
          currency
        }
        selectedSeats
        passengers {
          passengerId
          firstName
          lastName
          dateOfBirth
          passportNumber
          nationality
        }
        payment {
          intentId
          status
          amountCents
          currency
        }
        confirmationCode
      }
      agentNotes
      agentOverride {
        targetStep
        prefillSeat
        message
      }
    }
  }
`;

export const SEARCH_FLIGHTS = /* GraphQL */ `
  query SearchFlights($input: SearchFlightsInput!) {
    searchFlights(input: $input) {
      flightId
      flightNumber
      airline
      origin
      destination
      departureTime
      arrivalTime
      durationMinutes
      cabinClass
      price
      currency
      seatsAvailable
    }
  }
`;

export const GET_FLIGHT_SEAT_MAP = /* GraphQL */ `
  query GetFlightSeatMap($flightId: ID!) {
    getFlightSeatMap(flightId: $flightId) {
      flightId
      totalRows
      columns
      seats {
        seatId
        row
        column
        cabinClass
        status
        extraLegroom
        exitRow
        price
      }
    }
  }
`;

export const GET_MY_PROFILE = /* GraphQL */ `
  query GetMyProfile {
    getMyProfile {
      sub
      firstName
      lastName
      email
      phone
      loyaltyId
      loyaltyTier
      milesBalance
      enrolledAt
      accountStatus
      prefSeatLocation
      prefCabinClass
      prefMealType
      prefHomeAirport
      prefTravelType
      prefLanguage
      birthDate
      passportNumber
      addressLine1
      addressCity
      addressState
      addressZip
      addressCountry
      wizardCompleted
    }
  }
`;

export const GET_CALL_RECORDING_URL = /* GraphQL */ `
  query GetCallRecordingUrl($contactId: String!, $initiatedAt: String!) {
    getCallRecordingUrl(contactId: $contactId, initiatedAt: $initiatedAt) {
      url
      type
      participant
    }
  }
`;

export const GET_VOICE_ANALYSIS = /* GraphQL */ `
  query GetVoiceAnalysis($contactId: String!) {
    getVoiceAnalysis(contactId: $contactId) {
      contactId
      contactDate
      callerPhone
      analyzedAt
      channel
      languageCode
      totalDurationMs
      contactLensSummary
      skippedReason
      qa {
        modelId
        count
        items {
          index
          question
          askedBy
          answer
          answeredBy
          category
          resolution
          unableReason
        }
      }
    }
  }
`;

export const LIST_VOICE_ANALYSES = /* GraphQL */ `
  query ListVoiceAnalyses($startDate: String!, $endDate: String!) {
    listVoiceAnalyses(startDate: $startDate, endDate: $endDate) {
      contactId
      contactDate
      callerPhone
      analyzedAt
      channel
      languageCode
      totalDurationMs
      contactLensSummary
      skippedReason
      qa {
        modelId
        count
        items {
          index
          question
          askedBy
          answer
          answeredBy
          category
          resolution
          unableReason
        }
      }
    }
  }
`;

export const GET_ADMIN_DASHBOARD = /* GraphQL */ `
  query GetAdminDashboard($startDate: String, $endDate: String) {
    getAdminDashboard(startDate: $startDate, endDate: $endDate) {
      metrics {
        totalUsers
        wizardCompletedCount
        smsVerifiedCount
        usersWithBookings
        totalBookings
        totalCalls
        usersWhoCalled
        unmatchedCalls
        dlqMessageCount
      }
      users {
        sub email phone firstName lastName createdAt
        smsVerified wizardCompleted frequentFlyerNumber
        loyaltyTier milesBalance bookingCount callCount lastCallAt isAdmin
      }
      config {
        connectInstanceId
        tagFilters { key value }
        lookbackDays
        updatedAt
      }
      recentCalls {
        contactId phone initiatedAt durationSeconds
        channel profileFound customerName profileId matchedUserSub
      }
    }
  }
`;

export const LIST_MY_BOOKINGS = /* GraphQL */ `
  query ListMyBookings {
    listMyBookings {
      confirmationCode
      confirmedAt
      origin
      destination
      flightNumber
      departureTime
      arrivalTime
      durationMinutes
      price
      currency
      cabinClass
      selectedSeats
      passengerCount
      status
      passengers
    }
  }
`;

export const GET_INSIGHTS_RECOMMENDATIONS = /* GraphQL */ `
  query GetInsightsRecommendations {
    getInsightsRecommendations {
      generatedAt
      modelId
      dataWindowStart
      dataWindowEnd
      callsAnalyzed
      qaItemsAnalyzed
      recommendations {
        id
        title
        type
        impact
        summary
        evidence
        suggestion
        affectedCategories
        qaItemCount
        qaCitations {
          contactId
          qaIndex
          question
          unableReason
          category
          resolution
          contactDate
        }
      }
    }
  }
`;
